<template>
  <div id="basic-info" class="card mt-4">
    <div class="card-header">
      <h5>{{ $t('settings.Edit_notification') }}</h5>
    </div>
    <div class="card-body pt-0">
      <div class="row">        
          <div class="col-6">
              <div class="input-group input-group-static null">
                  <label>{{ $t('settings.Title') }} *</label>
                  <input v-model="state.title" type="text" class="form-control form-control-default" :placeholder="$t('settings.Title')">
                  <span v-if="v$.title.$error" class="text-sm text-danger">
                      {{ v$.title.$errors[0].$message }}
                  </span>
              </div>
          </div>
          <div class="col-6" v-if="['Admin'].includes(userRoleName)">
              <div class="input-group input-group-static null">
                  <label>{{ $t('settings.Association') }}</label>
                  <select id="associationId" v-model="state.associationId" class="form-control form-control-default">
                      <option value="">{{ $t('settings.Select_association') }}</option>
                      <option v-for="association in state.associations" :key="association.id" :value="association.id">
                          {{ association.abbreviation }}
                      </option>
                  </select>                  
              </div>
          </div>
      </div>
      <div class="row mt-4">
          <div class="col-12">
              <div class="input-group input-group-static null">
                  <label>{{ $t('settings.Message') }} *</label>
                  <textarea class="form-control form-control-default" :rows="5"
                      v-model="state.message"
                      :placeholder="$t('settings.Message')"></textarea>
                  <span v-if="v$.message.$error" class="text-sm text-danger">
                      {{ v$.message.$errors[0].$message }}
                  </span>
              </div>
          </div>
      </div>
      <div class="row mt-4">
          <div class="col-6">
              <div class="input-group input-group-static null">
                  <label class="d-block mb-1" style="width: inherit;">{{ $t('settings.Active') }}</label>
                  <div class="d-block mt-1">
                      <material-switch v-model="state.isactive" id="isActive" name="isactive" />
                  </div>
              </div>
          </div>
      </div>
      <div class="col-12 col-sm-12 mt-6">
        <input type="hidden" v-model="state.id" class="form-control">
        <router-link to="/settings" class="btn btn-sm bg-gradient-danger float-start">{{ $t('common.Cancel') }}</router-link>
        <button v-on:click="updateNotification" class="btn btn-sm bg-gradient-success mr-2 float-end">{{ $t('common.Update') }}</button>        
      </div>
    </div>
  </div>
</template>

<script>
import * as Choices from "choices.js";
import axios from 'axios'
import MaterialSwitch from "@/components/MaterialSwitch.vue";
import useValidate from '@vuelidate/core'
import { required, helpers, } from '@vuelidate/validators'
import { reactive, computed } from 'vue'
import { useI18n } from 'vue-i18n';
import { useStore } from 'vuex'

export default {
  name: "NotificationDetail",
  setup() {
    const { t } = useI18n()
    const store = useStore()

    const state = reactive({      
      id: '',
      title: '',
      message: '',
      isactive: false,
      associationId: '',
      associations:[],
      notification: []
    })

    const userRoleName = computed(() => store.state.user?.roleName)

    const rules = computed(() => {
      return {
        title: { required: helpers.withMessage(t('common.Required'), required) },
        message: { required: helpers.withMessage(t('common.Required'), required) }
      }
    })

    const v$ = useValidate(rules, state)

    return {
      state,
      userRoleName,
      choicesInstanceAssociation: null,
      v$
    }
  },
  components: {
    MaterialSwitch
  },
  data() {
    return {
      gets: [],
      error: '',
    };
  },
  async mounted() {
    this.id = this.$route.params.id;
    try {
      await this.fetchNotificationData(this.id);
    } catch (e) {        
      console.error('mounted: fetchUserManualData error', e);
    }
  },
  methods: {
    async fetchNotificationData(id) {
      try {
        
        this.$store.commit('setShowLoading', true);

        const response = await axios.get(`notification/${id}`);
        this.gets = response.data;

        if (this.gets.success) {
          this.state.notification = this.gets.data;
          this.state.id = this.state.notification.id;
          this.state.title = this.state.notification.title;
          this.state.message = this.state.notification.message;
          this.state.isactive = this.state.notification.isActive;
          this.state.associationId = this.state.notification.associationId;

          if (this.userRoleName === 'Admin') {
            await this.fetchAndPopulate({
              url: "Association/getall",
              listPath: "data.associationList",
              stateKey: "associations",
              selectId: "associationId",
              instanceKey: "choicesInstanceAssociation",
              selectedValueGetter: () => this.state.associationId
            });
          }
        } else {
          this.$showError('errors.Contact_system_admin');
        }
      } catch (e) {
        const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
        this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
      } finally {      
        this.$store.commit('setShowLoading', false);
      }
    },
    async fetchAndPopulate({
          url,
          listPath = "data",
          targetContainer = "state",
          stateKey,
          formKey,
          selectId,
          instanceKey,
          selectedValueGetter = () => null
      }) {
        try {
            const response = await axios.get(url);
            const result = response.data;
            
            const arr = listPath.split('.').reduce((acc, p) => (acc && acc[p] !== undefined) ? acc[p] : null, result);

            if (!result.success || !Array.isArray(arr)) {
                this.$showError(this.$t('errors.Error_fetching_data') || 'Error fetching data');
                return;
            }

            if (targetContainer === "formData" && formKey) {
                this.state[formKey] = arr;
            }

            if (stateKey) {
                this.state[stateKey] = arr;
            }
            
            if (selectId && instanceKey) {
                this.$nextTick(() => {
                    this.initializeChoicesDropdown({
                        id: selectId,
                        dataList: this.state[stateKey] || arr,
                        selectedValue: typeof selectedValueGetter === 'function' ? selectedValueGetter() : selectedValueGetter,
                        instanceKey
                    });
                });
            }
        } catch (e) {
            const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
            this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
        }
    },
    initializeChoicesDropdown({ id, dataList = [], selectedValue, instanceKey }) {
        const element = document.getElementById(id);
        if (!element || element.tagName !== "SELECT") {
        console.error(`Choices: Invalid or missing select element with ID "${id}".`);
        return;
        }

        if (this[instanceKey] && typeof this[instanceKey].destroy === 'function') {
            try { 
                this[instanceKey].destroy(); 
            } catch (err) { 
                console.warn('Choices destroy failed', err); 
            }
        }

        this[instanceKey] = new Choices(element, {
            searchEnabled: true,
            itemSelectText: '',
            shouldSort: false,
            placeholder: true,
        });
        
        const valueExists = (value) => {
            if (!value) return false;
            return dataList.some(item => {
                const v = item?.id ?? item?.Id ?? item?.ID ?? item?.value ?? item?.Value;                
                return String(v) === String(value);
            });
        };

        if (selectedValue) {
            const exists = valueExists(selectedValue);
            if (exists) {
                try {
                    this[instanceKey].setChoiceByValue([String(selectedValue)]);
                } catch (err) {
                    element.value = selectedValue;
                    element.dispatchEvent(new Event('change', { bubbles: true }));
                }
            } else {
                try {
                    this[instanceKey].clearStore();
                } catch (err) { 
                    /* ignore */ 
                }
            }
        }
    },
    async updateNotification() {
      try {
        this.$store.commit('setShowLoading', true);

        this.v$.$validate();
        console.log(this.v$.$error);

        if (!this.v$.$error) {
          const response = await axios.put('notification/update', {
            "id": this.state.id,
            "title": this.state.title,
            "message": this.state.message,
            "isactive": this.state.isactive,
            "associationId": this.state.associationId
          });
          this.gets = response.data;

          if (this.gets.success) {
            this.$showSuccess('errors.Success_notification_updated_successfully');
            this.$router.push('/settings');
          } else {
            this.$showError('errors.Contact_system_admin');            
          }
        }
      } catch (e) {
        const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
        this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
      } finally {
        this.$store.commit('setShowLoading', false);
      }
    },
  }
};
</script>